import request from './request';

export const getPaymentInfo = () =>
  request({
    url: '/payment_info/all',
    method: 'GET'
  });
